import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import associateServices from "../../../services";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";
import SelfExclusionStep1 from "./step1";
import SelfExclusionStep2 from "./step2";
import Loading from "../../../components/loading";

const SelfExclusion = () => {

    const {t} = useTranslation()

    const [loading, setLoading] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [data, setData] = useState({})

    const handleApiResponse = res => {
        setData(res?.data || {})

        setLoading(false)
    }

    const fetchData = () => {
        setLoading(true)
        associateServices.checkSelfExclusion({}).then(handleApiResponse)
    }
    useEffect(() => {
        fetchData()
    }, [])


    return (
        <div className="tab-pane fade show active">
            <div className="settings">
                <h3 className="settings__title">{t('self-exclusion.title')}</h3>
                <p className="settings__text">
                    {t('self-exclusion.desc')}
                </p>

            </div>

            {
                loading ? <Loading/> :
                    !data?.step || data?.step === 1 ?
                        <SelfExclusionStep1 data={data} reFetch={fetchData}/>
                        :
                        <SelfExclusionStep2 data={data} reFetch={fetchData}/>
            }
        </div>


    )

}

export default SelfExclusion
